export function capitalize(str: string): string {
  if (!str) {
    return "";
  }

  const [firstLetter, ...restOfWord] = str;

  return firstLetter.toUpperCase() + restOfWord.join("");
}

export function decodeHTMLString(str: string): string {
  if (!str) {
    return "";
  }

  return str
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
}
